import Gantt from "components/gantt-layout/Gantt/index";
import SidePanel from "../SidePanel/SidePanel";

interface SubTask {
  id: string;
  text: string;
  name_milestone: string;
  start_date: string | null;
  end_date: string | null;
  parent: string;
  type: string;
  risk_level: string;
  risk_assessment: string;
  current_step?: boolean;
  hoverText: {
    text: string;
    start_date: string | null;
    end_date: string | null;
    risk_level: string;
    risk_assessment: string;
  };
}

interface Task {
  risk_assessment?: any;
  id: string;
  text: string;
  start_date: string | null;
  end_date?: string | null;
  parent?: string;
  type?: string | number;
  risk_level?: string;
  activity_count?: number;
  open?: boolean;
  render?: string;
  milestones?: SubTask[];
}

interface Link {
  id: string;
  source: string;
  target: string;
  type: any;
}

interface GanttData {
  data: Task[];
  links: Link[];
}

interface SubmittalMaterialViewProps {
  task: GanttData;
  zoomSelection: string;
  togglePanel: () => void;
  isOpen: boolean;
}

export default function SubmittalMaterialView({
  task,
  zoomSelection,
  togglePanel,
  isOpen
}: SubmittalMaterialViewProps) {
  return (
    <div className={isOpen ? "gantt-container-squeezed" : "gantt-container"}>
      <Gantt tasks={task} zoom={zoomSelection} togglePanel={togglePanel} />
      <SidePanel isOpen={isOpen} />
    </div>
  );
}
